<script>
  import SiteHeader from "../components/SiteHeader.svelte";
  import SiteFooter from "../components/SiteFooter.svelte";
</script>

<div class="shell"><SiteHeader /><main><p>404</p><h1>That page is not here.</h1><a href="/">Return to Widely →</a></main><SiteFooter /></div>

<style>
  .shell{min-height:100vh;background:#0b0b0c;color:#f5f5f0}main{width:min(100% - 40px,1120px);min-height:68vh;margin:auto;padding:100px 0}p{margin:0 0 20px;color:#a4f465;font-weight:700;letter-spacing:.14em}h1{max-width:800px;margin:0 0 40px;font-size:clamp(3.5rem,9vw,8rem);font-weight:620;letter-spacing:-.07em;line-height:.9}a{color:#f5f5f0;text-underline-offset:5px}@media(max-width:640px){main{width:calc(100% - 32px)}}
</style>
